import { render } from "./ListaContratacoesVigentesView.vue?vue&type=template&id=364524d9&scoped=true"
import script from "./ListaContratacoesVigentesView.vue?vue&type=script&lang=js"
export * from "./ListaContratacoesVigentesView.vue?vue&type=script&lang=js"

import "./ListaContratacoesVigentesView.vue?vue&type=style&index=0&id=364524d9&scoped=true&lang=css"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-364524d9"]])

export default __exports__